<template>
  <wt-selector :options="options" :disabled="disabled" v-model="Value" :clearable="true" :multiple="hasExamList" :filterable="filterable"></wt-selector>
</template>
<script>
export default {
  name: 'lab-product-selector',
  props: {
    value: {
      type: [String, Array],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labExamItemList: Array,
		filterable:Boolean,
    hasExamList: Boolean// 委托单页面，从委托单信息中获取到检测列表将不再请求
  },
  data () {
    return {
      Value: this.value,
      options: []
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
      this.$emit('productChenge', this.Value)
    },
    labExamItemList: {
      handler: function (val) {
        if (val && this.hasExamList) {
          this.options = val.map(item => {
            return {
              label: item.itemName,
              value: item.id
            }
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    getOptions () {
      let params = {
        example: { organizationRole: 'LAB' },
        pageableParam: { page: 0, size: 9999, sort: ['createdDate,asc'] }
      }
      let options = []
      this.$store.dispatch('getLabProductList', params).then(res => {
        res.data.forEach(ele => {
          let obj = {
            label: ele.itemName,
            value: ele.id
          }
          options.push(obj)
        })
        this.options = options
        // if (options.length === 1) {
        //   this.Value = options[0].value
        // }
      })
    }
  },
  created () {
    if (!this.hasExamList) {
      this.getOptions()
    }
  }
}
</script>
